import {
  type DocumentCreationRequest,
  type DocumentCreationRequestAPI,
  type DocumentCreationResponse,
  type DocumentCreationResponseAPI,
  type DocumentItem,
  type DocumentItemAPI,
  type Documents,
  type DocumentsAPI,
  DocumentType,
} from '@omnipresentgroup/types';

export const transformDocumentItemFromAPI = (
  item: DocumentItemAPI,
): DocumentItem => ({
  userId: item.userId,
  description: item.description,
  scanStatus: item.scanStatus,
  id: item.id,
  tenantId: item.tenantId,
  ownerId: item.ownerId,
  linkToDocument: item.linkToDocument,
  type: item.type,
  title: item.title,
  createdAt: item.createdAt,
  scannedAt: item.scannedAt,
  actions: item.actions,
});

export const transformDocumentsFromAPI = (api: DocumentsAPI): Documents => ({
  items: api.items.map((item) => transformDocumentItemFromAPI(item)),
  actions: api.actions,
});

export const transformDocumentCreateRequestToAPI = (
  request: DocumentCreationRequest,
): DocumentCreationRequestAPI => ({
  linkToDocument: request.linkToDocument,
  type: request.type ?? DocumentType.DOCUMENT,
  title: request.title,
  description: request.description,
  userId: request.userId,
  tenantId: request.tenantId,
  metadata: request.metadata,
});

export const transformDocumentCreateResponseFromAPI = (
  response: DocumentCreationResponseAPI,
): DocumentCreationResponse => ({
  id: response.id,
  message: response.message,
  url: response.url,
});
